import PageSettings from './PageSettings';

export default {
  install(Vue) {
    Vue.use(PageSettings);
  },
};
